import Axios from 'axios';

// Auth payload from sessionStorage only (OWASP A02 - no token in localStorage)
function getAuthPayloadSync() {
    try {
        const raw = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('auth_payload') : null;
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
}

// Global Axios Interceptor to inject roleId and X-Acting-Role (for backend RBAC)
Axios.interceptors.request.use((config) => {
    try {
        const payload = getAuthPayloadSync();
        if (payload && typeof payload === 'object') {
            // Backend RBAC: send selected role so access is checked against this role only (multi-role users)
                const roleCode = payload.roleCode;
                if (roleCode && String(roleCode).trim()) {
                    const actingRole = String(roleCode).toLowerCase().trim();
                    config.headers = config.headers || {};
                    config.headers['X-Acting-Role'] = actingRole;
                }

                if (payload.roleId !== undefined && payload.roleId !== null && payload.roleId !== '') {
                    // Inject into body data if it's an object
                    if (config.data && typeof config.data === 'object' && !Array.isArray(config.data)) {
                        if (config.data.roleId === undefined || config.data.roleId === null || config.data.roleId === '') {
                            config.data.roleId = payload.roleId;
                        }
                    }
                    // Also inject into query params
                    if (config.params) {
                        if (config.params.roleId === undefined || config.params.roleId === null || config.params.roleId === '') {
                            config.params.roleId = payload.roleId;
                        }
                    } else if (config.method === 'get') {
                        config.params = config.params || {};
                        config.params.roleId = payload.roleId;
                    }
                }
        }
    } catch (e) {
        // Silently fail to not block the request
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
